import { Component } from "./component";
import * as noUiSlider from "nouislider";
import wNumb from "wnumb";

export function SliderFactory(element: HTMLElement, blazorElement: any) {
  return new Slider(element, blazorElement);
}

export enum SliderMode {
    Linear,
    NonLinear
}

export class Slider extends Component {
  constructor(public element: HTMLElement, public blazorElement: any) {
    super(element, blazorElement);
  }

  initialize() {}

  initializeSlider(options: any) {

    console.log(options);

    let slider = this.element;

    let sliderOptions: noUiSlider.Options = {
      start: options.start,
      snap: options.snap,
      range: { min: options.min, max: options.max }, 
      tooltips: options.tooltips
        ? options.format
          ? wNumb(options.format)
          : true
        : false,
      format: options.format ? wNumb(options.format) : null,
      pips: options.pips
        ? {
            format: options.pips.format
              ? wNumb(options.pips.format)
              : options.format
              ? wNumb(options.format)
              : null,
            mode: options.pips.mode,
            values: options.pips.values,
            density: options.pips.density,
            stepped: options.pips.stepped,
          }
        : undefined,
    };

    if(options.mode == SliderMode.NonLinear)
    { 
        var range = { "min": 0, "max": 0};

        for(var step of options.range)
        {
            range[step.percentage] = step.value;
        }

        sliderOptions.range = range;
    }
    else {
        sliderOptions.step = options.step;
    }

    if (options.pips) {
      sliderOptions.pips.filter = function (value) {
        var type = -1;
        if (options.pips.filterMultiples) {
          options.pips.filterMultiples.forEach(function (filterMultiple) {
            if (value % filterMultiple.multiple == 0) {
              type = filterMultiple.pipType;
            }
          });
        }
        if (options.pips.alwaysShowMinMax) {
          if (
            value === sliderOptions.range.min ||
            value === sliderOptions.range.max
          ) {
            type = 1;
          }
        }
        return type;
      };
    }

    noUiSlider.create(slider, sliderOptions);

    slider["noUiSlider"].on("set", this.onSet.bind(this));
  }

  toggleEnableSlider(disable) {
    if (disable) {
      this.element.setAttribute("disabled", String(true));
    } else {
      this.element.removeAttribute("disabled");
    }
  }

  filterPips(value) {
    return value % 100 ? 0 : 1;
  }

  async onSet(values, handle, unencoded, tap, positions, noUiSlider) {
      console.log(this.blazorElement);
    if (unencoded.length > 1) {
      await this.blazorElement.invokeMethodAsync( 
        "UpdateMultipleValues",
        unencoded
      );
    } else {
      await this.blazorElement.invokeMethodAsync( 
        "UpdateSingleValue",
        unencoded[0]
      );
    }
  }
}
